import BaseAPIService from './base.service';

export default class CrewMemberAPIService extends BaseAPIService {
  apiBase: string | undefined;
  rootEndpoint: string;

  constructor(apiBase?: string) {
    super();
    this.rootEndpoint = '/api/crew-member';
    if (apiBase) this.apiBase = apiBase;
  }

  async createCrewMember(project: Project, crewMember: CrewMember) {
    try {
      const endpoint = `${this.rootEndpoint}`;
      const res = await super.post({ apiBase: this.apiBase, endpoint, data: { ...crewMember, projectId: project.id } });

      return res.json();
    } catch (err: any) {
      console.log('CrewMemberAPIService::create:: ', err);
      throw new Error(err.message);
    }
  }

  async updateCrewMember(project: Project, crewMember: CrewMember) {
    try {
      const endpoint = `${this.rootEndpoint}/${crewMember.id}`;
      const res = await super.put({ apiBase: this.apiBase, endpoint, data: { ...crewMember, projectId: project.id } });

      return res.json();
    } catch (err: any) {
      console.log('CrewMemberAPIService::update:: ', err);
      throw new Error(err.message);
    }
  }

  async joinCrewMember(crewMemberId: number) {
    try {
      const endpoint = `${this.rootEndpoint}/${crewMemberId}/join`;
      const res = await super.put({ apiBase: this.apiBase, endpoint, data: {} });

      return res.json();
    } catch (err: any) {
      console.log('CrewMemberAPIService::join:: ', err);
      throw new Error(err.message);
    }
  }

  async deleteCrewMember(crewMember: CrewMember) {
    try {
      const endpoint = `${this.rootEndpoint}/${crewMember.id}`;
      const res = await super.delete({ apiBase: this.apiBase, endpoint, data: crewMember });

      return res.json();
    } catch (err: any) {
      console.log('CrewMemberAPIService::delete:: ', err);
      throw new Error(err.message);
    }
  }
}
